function hasChildrenDisabledElement(array: HTMLCollection) {
  for (const node of array) {
    if (node.attributes.getNamedItem('disabled')) return true;
    if (node.children) {
      const child = hasChildrenDisabledElement(node.children);
      if (child) return true;
    }
  }

  return false;
}

export function hasDisabledElement(element: Element) {
  if (element.attributes.getNamedItem('disabled')) {
    return true;
  }
  return hasChildrenDisabledElement(element.children);
}
